import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "border-b border-slate-300 px-6 py-5 text-xl font-light text-slate-700" }
const _hoisted_2 = { class: "mt-2 flex flex-col-reverse items-start items-stretch px-6 pb-10 md:flex-row" }
const _hoisted_3 = { class: "LEFTBAR md:pr-12" }
const _hoisted_4 = { class: "mt-5 whitespace-nowrap font-bold" }
const _hoisted_5 = { class: "whitespace-nowrap font-bold" }
const _hoisted_6 = { class: "DocsContent flex-1 max-w-full overflow-auto" }
const _hoisted_7 = { class: "mx-3 mt-5 md:mx-32" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "RIGHTBAR hidden md:block" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-2 font-bold" }, "On this page", -1)
const _hoisted_11 = {
  key: 0,
  class: "u"
}
const _hoisted_12 = ["href", "innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MainLayout = _resolveComponent("MainLayout")!

  return (_openBlock(), _createBlock(_component_MainLayout, { showPadding: false }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.toolName) + " Documentation\n    ", 1),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.links)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.links, (group, i1) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: `title-${i1}`
                }, [
                  _createElementVNode("h3", _hoisted_4, _toDisplayString(group.title), 1),
                  _createTextVNode(),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item, i2) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: `title-${i1}-${i2}`
                    }, [
                      (item.items)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("h4", _hoisted_5, _toDisplayString(item.title), 1),
                            _createTextVNode(),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (itm, i3) => {
                              return (_openBlock(), _createBlock(_component_router_link, {
                                key: `link-${i1}-${i2}-${i3}`,
                                class: _normalizeClass([{ isSelected: _ctx.isSelected(itm.link) }, "block whitespace-nowrap"]),
                                to: itm.link
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(itm.title), 1)
                                ]),
                                _: 2
                              }, 1032, ["class", "to"]))
                            }), 128))
                          ], 64))
                        : (_openBlock(), _createBlock(_component_router_link, {
                            key: 1,
                            class: _normalizeClass([{ isSelected: _ctx.isSelected(item.link) }, "block whitespace-nowrap"]),
                            to: item.link
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.title), 1)
                            ]),
                            _: 2
                          }, 1032, ["class", "to"]))
                    ], 64))
                  }), 128))
                ], 64))
              }), 128))
            : _createCommentVNode("", true)
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "post mb",
              innerHTML: _ctx.page.content,
              ref: _ctx.content
            }, null, 8, _hoisted_8)
          ]),
          _createTextVNode()
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.page.subtitles?.length && _ctx.page.subtitles[0].depth === 2)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_10,
                _createTextVNode(),
                (_ctx.page.subtitles.length)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.page.subtitles, (subtitle) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: _normalizeClass('depth-' + subtitle.depth),
                          key: subtitle.value
                        }, [
                          _createElementVNode("a", {
                            href: subtitle.anchor,
                            innerHTML: subtitle.value.replace(' W3C', '').split(/\s/g).join(' ')
                          }, null, 8, _hoisted_12)
                        ], 2))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}